<template>
  <div class="project-data">
    <!-- 取店池弹窗 -->
    <el-dialog title="取店池" :visible.sync="poolDialogVisible" width="960px" :close-on-click-modal="false" custom-class="pool-dialog">
      <div class="pool-header">
        <div class="pool-info">
          <span class="pool-count">已取 <b>{{ myClaimCount }}</b> / {{ maxClaimCount }} 家</span>
          <el-progress :percentage="myClaimCount / maxClaimCount * 100" :show-text="false" :stroke-width="6" style="width:120px;margin-left:12px;"></el-progress>
        </div>
        <div class="pool-actions">
          <el-input v-model="poolKeyword" placeholder="搜索代码/名称" prefix-icon="el-icon-search" clearable size="small" style="width:200px;" @keyup.enter.native="loadPool"></el-input>
          <el-button type="primary" size="small" icon="el-icon-download" @click="batchClaim" :disabled="poolSelected.length === 0">取店 ({{ poolSelected.length }})</el-button>
        </div>
      </div>
      <el-table :data="poolData" v-loading="poolLoading" @selection-change="poolSelected = $event" row-key="dealerId" style="width:100%;" max-height="450">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" label="#" width="50"></el-table-column>
        <el-table-column prop="dealerCode" label="经销商代码" min-width="110"></el-table-column>
        <el-table-column prop="dealerName" label="经销商名称" min-width="150"></el-table-column>
        <el-table-column prop="daquName" label="大区" width="100"></el-table-column>
        <el-table-column prop="xiaoquName" label="小区" width="100"></el-table-column>
        <el-table-column prop="waveName" label="波次" width="120"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="claimOne(row)">取店</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next" :current-page.sync="poolPage" :page-size="20" :total="poolTotal" @current-change="loadPool" style="margin-top:16px;text-align:right;"></el-pagination>
    </el-dialog>

    <!-- 待分配池弹窗 -->
    <el-dialog title="待分配池" :visible.sync="pendingDialogVisible" width="960px" :close-on-click-modal="false" custom-class="pool-dialog">
      <div class="pool-header">
        <div class="pool-info"><span style="font-weight:600;">待处理门店</span></div>
        <div class="pool-actions">
          <el-input v-model="pendingKeyword" placeholder="搜索代码/名称" prefix-icon="el-icon-search" clearable size="small" style="width:200px;" @keyup.enter.native="loadPending"></el-input>
        </div>
      </div>
      <el-table :data="pendingData" v-loading="pendingLoading" row-key="dealerId" style="width:100%;" max-height="450">
        <el-table-column type="index" label="#" width="50"></el-table-column>
        <el-table-column prop="dealerCode" label="经销商代码" min-width="110"></el-table-column>
        <el-table-column prop="dealerName" label="经销商名称" min-width="150"></el-table-column>
        <el-table-column prop="waveName" label="波次" width="120"></el-table-column>
        <el-table-column label="释放标签" width="120">
          <template slot-scope="{ row }">
            <el-tag v-if="row.tag" type="warning" size="small">⚠️ {{ row.tag }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150"></el-table-column>
        <el-table-column prop="releasedBy" label="释放人" width="100"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="showAssignDialog(row)">指派</el-button>
            <el-button type="text" size="small" style="color:#f56c6c;" @click="rejectDealer(row)">驳回</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next" :current-page.sync="pendingPage" :page-size="20" :total="pendingTotal" @current-change="loadPending" style="margin-top:16px;text-align:right;"></el-pagination>
    </el-dialog>

    <!-- 释放弹窗 -->
    <el-dialog title="释放门店" :visible.sync="releaseDialogVisible" width="450px" :close-on-click-modal="false" custom-class="pool-dialog">
      <el-form label-width="100px">
        <el-form-item label="释放标签" required>
          <el-radio-group v-model="releaseForm.tag">
            <el-radio label="没时间做" style="margin-right:20px;margin-bottom:10px;">没时间做</el-radio>
            <el-radio label="方言" style="margin-right:20px;margin-bottom:10px;">方言</el-radio>
            <el-radio label="样本不全" style="margin-right:20px;margin-bottom:10px;">样本不全</el-radio>
            <el-radio label="其他" style="margin-bottom:10px;">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" :required="releaseForm.tag === '样本不全' || releaseForm.tag === '其他'">
          <el-input v-model="releaseForm.remark" type="textarea" :rows="3" placeholder="请填写释放原因"></el-input>
        </el-form-item>
        <el-form-item>
          <div style="color:#e6a23c;font-size:12px;">
            <template v-if="releaseForm.tag === '没时间做'">门店将回到取店池，其他QC可取。</template>
            <template v-else-if="releaseForm.tag">门店将进入待分配池，由内部QC处理。</template>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="releaseDialogVisible = false" round>取消</el-button>
        <el-button type="danger" @click="confirmRelease" :loading="releaseSubmitting" round>确认释放</el-button>
      </div>
    </el-dialog>

    <!-- 指派弹窗 -->
    <el-dialog title="指派门店" :visible.sync="assignDialogVisible" width="400px" :close-on-click-modal="false" custom-class="pool-dialog">
      <el-form label-width="100px">
        <el-form-item label="指派给">
          <el-select v-model="assignForm.userId" placeholder="选择兼职QC" filterable style="width:100%;">
            <el-option v-for="r in reviewerOptions" :key="r.id" :label="r.name" :value="r.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="assignDialogVisible = false" round>取消</el-button>
        <el-button type="primary" @click="confirmAssign" :loading="assignSubmitting" round>确认指派</el-button>
      </div>
    </el-dialog>

    <div class="page-header">
      <h3>当前波次</h3>
      <div class="header-center">
        <el-select v-model="selectedWaveId" placeholder="选择波次" @change="loadDealerData" clearable size="small" class="form-select-inline">
          <template slot="prefix">选择波次：</template>
          <el-option 
            v-for="wave in waveOptions" 
            :key="wave.id" 
            :label="wave.name" 
            :value="wave.id"
          ></el-option>
        </el-select>
      </div>
      <div class="header-actions">
        <el-button 
          v-if="selectedWaveId && !isReviewerRole" 
          type="primary" 
          icon="el-icon-download" 
          @click="exportWaveData"
          size="small"
        >
          导出当前数据
        </el-button>
      </div>
    </div>

    <!-- 筛选区域 -->
    <div class="filter-bar" v-if="selectedWaveId">
      <el-input 
        v-model="searchKeyword" 
        placeholder="搜索店代码/名称" 
        prefix-icon="el-icon-search"
        clearable
        style="width: 200px"
        @clear="handleSearch"
        @keyup.enter.native="handleSearch"
      ></el-input>
      <el-select v-model="phaseFilter" placeholder="阶段筛选" clearable @change="handleSearch" style="width: 140px">
        <el-option v-for="p in currentPhases" :key="p.phaseNo" :label="p.phaseName" :value="p.phaseNo"></el-option>
      </el-select>
      <el-select v-model="statusFilter" placeholder="审核状态" clearable @change="handleSearch" style="width: 140px">
        <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
      </el-select>
      <el-select v-model="appealFilter" placeholder="申诉状态" clearable @change="handleSearch" style="width: 140px">
        <el-option label="已下发申诉" value="appealed"></el-option>
        <el-option label="未下发申诉" value="not_appealed"></el-option>
      </el-select>
      <el-select v-if="isInternalQc" v-model="qcFilter" placeholder="QC账号筛选" clearable @change="handleSearch" style="width: 140px">
        <el-option v-for="name in qcAccountOptions" :key="name" :label="name" :value="name"></el-option>
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
      <el-button icon="el-icon-refresh" @click="resetFilters">重置</el-button>
      <el-button 
        v-if="canDistributeAppeal"
        type="warning" 
        icon="el-icon-s-promotion" 
        @click="showAppealDialog"
      >
        下发申诉 {{ selectedRows.length > 0 ? '(' + selectedRows.length + ')' : '' }}
      </el-button>
      <el-button 
        v-if="isReviewerRole"
        type="warning" 
        icon="el-icon-shopping-bag-2" 
        @click="openPoolDialog"
      >
        取店池
      </el-button>
      <el-button 
        v-if="isReviewerRole"
        type="danger" 
        icon="el-icon-unlock" 
        :disabled="selectedRows.length === 0"
        @click="showReleaseDialog(selectedRows)"
      >
        释放门店 {{ selectedRows.length > 0 ? '(' + selectedRows.length + ')' : '' }}
      </el-button>
      <el-button 
        v-if="isInternalQc"
        type="warning" 
        icon="el-icon-s-claim" 
        @click="openPendingDialog"
      >
        待分配 {{ pendingTotal > 0 ? '(' + pendingTotal + ')' : '' }}
      </el-button>
    </div>

    <!-- 数据统计概览 -->
    <div class="stats-row" v-if="selectedWaveId">
      <div class="stat-card">
        <div class="stat-header"><span class="stat-label">总店数</span></div>
        <div class="stat-icon icon-total"><i class="el-icon-office-building"></i></div>
        <div class="stat-value">{{ dataStats.totalDealers }}</div>
        <div class="stat-bar bar-blue"></div>
      </div>
      <div class="stat-card">
        <div class="stat-header"><span class="stat-label">已提交</span></div>
        <div class="stat-icon icon-today"><i class="el-icon-document-checked"></i></div>
        <div class="stat-value">{{ dataStats.submittedCount }}</div>
        <div class="stat-bar bar-blue"></div>
      </div>
      <div class="stat-card">
        <div class="stat-header"><span class="stat-label">待审核</span></div>
        <div class="stat-icon icon-week"><i class="el-icon-edit-outline"></i></div>
        <div class="stat-value">{{ dataStats.pendingReview }}</div>
        <div class="stat-bar bar-blue"></div>
      </div>
      <div class="stat-card">
        <div class="stat-header"><span class="stat-label">完成率</span></div>
        <div class="stat-icon icon-time"><i class="el-icon-data-line"></i></div>
        <div class="stat-value">{{ dataStats.completionRate }}%</div>
        <div class="stat-bar bar-blue"></div>
      </div>
    </div>

    <!-- 店维度数据表格 -->
    <div class="data-table" v-if="selectedWaveId">
      <div class="table-toolbar">
        <el-input 
          v-model="searchKeyword" 
          placeholder="搜索经销商代码或名称..." 
          prefix-icon="el-icon-search"
          clearable
          size="small"
          class="search-input"
          @clear="handleSearch"
          @keyup.enter.native="handleSearch"
        ></el-input>
        <div class="toolbar-icons">
          <!-- 42 号方案 §10.8.7 批量作废入口（仅研究员 + 管理员）-->
          <el-button v-if="canGovernDealer && selectedRows.length > 0"
                     size="small" type="warning" plain icon="el-icon-close"
                     style="margin-right: 8px;"
                     @click="openBatchVoidDialog">
            批量作废 ({{ selectedRows.length }})
          </el-button>
          <i class="el-icon-set-up toolbar-icon" title="筛选" @click="handleSearch"></i>
        </div>
      </div>
      <el-table ref="dataTable" :data="tableData" v-loading="loading" style="width: 100%" @selection-change="handleSelectionChange" row-key="dealerId">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column label="经销商代码" min-width="110">
          <template slot-scope="{ row }">
            <span :class="{ 'voided-row-text': isDealerVoided(row) }">{{ row.dealerCode || '-' }}</span>
            <!-- 42 号方案 §10.8.7：已作废门店标签 -->
            <el-tooltip v-if="isDealerVoided(row)" effect="dark" placement="top">
              <div slot="content">
                <div>作废原因：{{ dealerVoidInfo(row).reason || '-' }}</div>
                <div>操作人：{{ dealerVoidInfo(row).by || '-' }}</div>
                <div>时间：{{ dealerVoidInfo(row).at || '-' }}</div>
              </div>
              <el-tag size="mini" type="info" style="margin-left: 6px;">已作废</el-tag>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="经销商名称" min-width="150">
          <template slot-scope="{ row }">
            <span :class="{ 'voided-row-text': isDealerVoided(row) }">{{ row.dealerName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="代理" width="100" v-if="!isInternalQc && !isReviewerRole">
          <template slot-scope="{ row }">
            <span v-if="row.agentName">{{ row.agentName }}</span>
            <span v-else style="color:#9ca3af;">—</span>
          </template>
        </el-table-column>
        <el-table-column label="QC账号" width="100" v-if="!isOpsRole && !isReviewerRole">
          <template slot-scope="{ row }">
            <span v-if="row.qcName">{{ row.qcName }}</span>
            <span v-else style="color:#9ca3af;">—</span>
          </template>
        </el-table-column>
        <!-- 动态阶段列 -->
        <el-table-column 
          v-for="phase in currentPhases" 
          :key="phase.phaseNo" 
          :label="phase.phaseName" 
          width="120" 
          align="center"
        >
          <template slot-scope="{ row }">
            <span 
              class="phase-status-tag" 
              :class="getPhaseStatusClass(getPhaseData(row, phase.phaseNo))"
              @click="handlePhaseClick(row, phase.phaseNo)"
              :style="{ cursor: getPhaseData(row, phase.phaseNo).answerKey ? 'pointer' : 'default' }"
            >
              {{ getPhaseData(row, phase.phaseNo).statusText }}
            </span>
          </template>
        </el-table-column>
        <!-- 展开行 -->
        <el-table-column type="expand">
          <template slot-scope="{ row }">
            <div class="expand-phases">
              <div v-for="phase in getRowPhases(row)" :key="phase.PhaseNo || phase.phaseNo" class="phase-detail-card">
                <div class="phase-detail-header">
                  <span class="phase-detail-name">{{ phase.PhaseName || phase.phaseName }}</span>
                  <span class="phase-status-tag" :class="getPhaseStatusClass(getPhaseData(row, phase.PhaseNo || phase.phaseNo))">{{ getPhaseData(row, phase.PhaseNo || phase.phaseNo).statusText }}</span>
                </div>
                <template v-if="isPhaseSubmitted(phase)">
                  <div class="phase-detail-info" v-if="phase.AnswerKey || phase.answerKey || phase.SubmitTime || phase.submitTime">
                    <span>提交时间：{{ formatTime(phase.SubmitTime || phase.submitTime) }}</span>
                    <span>用时：{{ formatDuration(phase.Duration || phase.duration) }}</span>
                  </div>
                  <div class="phase-detail-info">
                    <!-- 第3阶段：三级审核 -->
                    <span v-if="getPhaseNo(phase) === 3">
                      审核：
                      <i :class="getAuditStatus(phase) >= 1 ? 'el-icon-check review-done' : 'el-icon-close review-pending'"></i>一审
                      <i :class="getAuditStatus(phase) >= 2 ? 'el-icon-check review-done' : 'el-icon-close review-pending'" style="margin-left:8px;"></i>二审
                      <i :class="getAuditStatus(phase) >= 3 ? 'el-icon-check review-done' : 'el-icon-close review-pending'" style="margin-left:8px;"></i>三审
                    </span>
                    <!-- 第1/2/4阶段：简单审核状态 -->
                    <span v-else>
                      审核：<span v-if="getAuditStatus(phase) >= 1" class="review-done">通过</span>
                      <span v-else-if="getAuditStatus(phase) === -1" class="review-reject">不通过</span>
                      <span v-else class="review-pending-text">待审核</span>
                    </span>
                  </div>
                  <div class="phase-detail-actions">
                    <el-button type="text" class="action-view" icon="el-icon-view" @click="viewDetail(phase)">查看</el-button>
                    <el-button type="text" class="action-audit" icon="el-icon-edit-outline" @click="reviewAnswer(phase)">审核</el-button>
                    <!-- 删除按钮降级为仅超管可见（42 号方案 §10.8.7）-->
                    <el-button v-if="isSuperAdmin" type="text" class="action-delete" icon="el-icon-delete" @click="deleteAnswer(phase)">删除</el-button>
                  </div>
                </template>
                <div v-else class="phase-detail-info" style="color:#9ca3af;">暂无提交</div>
              </div>

              <!-- 42 号方案 §10.8.7：门店级作废 / 恢复 操作栏（仅研究员 + 管理员可见） -->
              <div class="dealer-void-actions" v-if="canGovernDealer">
                <el-button v-if="!isDealerVoided(row)" size="small" type="warning" plain
                           icon="el-icon-close" @click="openVoidDealerDialog(row)">
                  作废门店
                </el-button>
                <template v-else>
                  <el-button size="small" type="primary" plain icon="el-icon-refresh-left"
                             @click="openUnvoidDealerDialog(row)">
                    恢复门店
                  </el-button>
                  <el-button size="small" type="text" @click="showDealerVoidLog(row)">
                    <i class="el-icon-time"></i> 作废记录
                  </el-button>
                </template>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page.sync="page"
          :page-size="pageSize"
          :total="total"
          @current-change="loadDealerData"
        ></el-pagination>
      </div>
    </div>

    <!-- 空状态提示 -->
    <div class="empty-state" v-if="!selectedWaveId">
      <i class="el-icon-document"></i>
      <p>请选择一个波次查看数据</p>
    </div>

    <!-- 导出进度遮罩 -->
    <div class="export-overlay" v-if="exporting">
      <div class="export-progress-card">
        <i class="el-icon-loading"></i>
        <p class="export-title">正在导出数据...</p>
        <el-progress :percentage="exportProgress" :stroke-width="8"></el-progress>
        <p class="export-tip">大数据量导出可能需要较长时间，请耐心等待</p>
      </div>
    </div>

    <!-- 下发申诉对话框 -->
    <el-dialog
      :visible.sync="appealDialogVisible"
      :width="appealDialogMode === 'batch' ? '720px' : '520px'"
      custom-class="appeal-dialog"
      :show-close="true"
      :close-on-click-modal="false"
    >
      <template slot="title">
        <div class="dialog-custom-title">
          <i class="el-icon-s-promotion"></i>
          <span>{{ appealDialogMode === 'batch' ? '批量下发申诉' : '下发申诉' }}</span>
        </div>
      </template>
      <!-- 常规模式 -->
      <template v-if="appealDialogMode === 'selection'">
        <el-form :model="appealForm" label-width="100px" class="appeal-form">
          <el-form-item label="批次名称">
            <el-input v-model="appealForm.batchName" placeholder="如：2026年3月测试申诉" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="申诉月份">
            <div style="display: flex; gap: 10px;">
              <el-select v-model="appealForm.appealYear" placeholder="年份" style="width: 50%">
                <el-option v-for="y in [2023, 2024, 2025, 2026, 2027]" :key="y" :label="y + '年'" :value="y"></el-option>
              </el-select>
              <el-select v-model="appealForm.appealMonthNum" placeholder="月份" style="width: 50%">
                <el-option v-for="m in 12" :key="m" :label="m + '月'" :value="m"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="选中门店">
            <span class="appeal-count-badge">{{ selectedRows.length }} 家</span>
          </el-form-item>
          <el-form-item label="申诉开始时间">
            <el-date-picker v-model="appealForm.startTime" type="datetime" placeholder="选择开始时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"></el-date-picker>
          </el-form-item>
          <el-form-item label="申诉截止时间">
            <el-date-picker v-model="appealForm.endTime" type="datetime" placeholder="选择截止时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"></el-date-picker>
          </el-form-item>
        </el-form>
      </template>
      <!-- 批量模式 -->
      <template v-else>
        <el-form :model="appealForm" label-width="100px" class="appeal-form">
          <el-form-item label="批次名称">
            <el-input v-model="appealForm.batchName" placeholder="如：2026年3月测试申诉" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="申诉月份">
            <div style="display: flex; gap: 10px;">
              <el-select v-model="appealForm.appealYear" placeholder="年份" style="width: 50%">
                <el-option v-for="y in [2023, 2024, 2025, 2026, 2027]" :key="y" :label="y + '年'" :value="y"></el-option>
              </el-select>
              <el-select v-model="appealForm.appealMonthNum" placeholder="月份" style="width: 50%">
                <el-option v-for="m in 12" :key="m" :label="m + '月'" :value="m"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="店铺名单">
            <el-input type="textarea" v-model="batchAppealText" :rows="5" placeholder="请粘贴店铺代码或名称，每行一个（支持从Excel复制）"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="parseBatchDealers" :loading="batchChecking" icon="el-icon-search" round size="small">解析名单</el-button>
          </el-form-item>
          <el-form-item label="解析结果" v-if="batchCheckResult.length > 0">
            <el-table :data="batchCheckResult" size="small" max-height="300" style="border-radius: 8px; overflow: hidden;">
              <el-table-column prop="keyword" label="输入" width="120"></el-table-column>
              <el-table-column prop="dealerName" label="店铺名称" min-width="120"></el-table-column>
              <el-table-column prop="waveName" label="所属波次" width="100"></el-table-column>
              <el-table-column label="状态" width="130">
                <template slot-scope="{ row }">
                  <el-tag v-if="row.canAppeal" type="success" size="small" effect="light">可下发</el-tag>
                  <el-tag v-else type="danger" size="small" effect="light">{{ row.message }}</el-tag>
                </template>
              </el-table-column>
            </el-table>
            <div class="batch-result-summary">可下发：<strong>{{ batchCanAppealCount }}</strong> 份</div>
          </el-form-item>
          <el-form-item label="申诉开始时间">
            <el-date-picker v-model="appealForm.startTime" type="datetime" placeholder="选择开始时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"></el-date-picker>
          </el-form-item>
          <el-form-item label="申诉截止时间">
            <el-date-picker v-model="appealForm.endTime" type="datetime" placeholder="选择截止时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"></el-date-picker>
          </el-form-item>
        </el-form>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click="appealDialogVisible = false" round>取消</el-button>
        <el-button v-if="appealDialogMode === 'selection'" type="primary" @click="submitAppeal" :loading="appealSubmitting" round icon="el-icon-s-promotion">确认下发</el-button>
        <el-button v-else type="primary" @click="submitBatchAppeal" :loading="appealSubmitting" :disabled="batchCanAppealCount === 0" round icon="el-icon-s-promotion">确认下发 ({{ batchCanAppealCount }})</el-button>
      </div>
    </el-dialog>

    <!-- ===== 42 号方案 §10.8：作废门店弹窗 ===== -->
    <el-dialog title="作废门店确认" :visible.sync="voidDealerDialogVisible" width="540px" :close-on-click-modal="false">
      <div v-if="voidDealerTargets.length > 0">
        <p>将作废 <strong>{{ voidDealerTargets.length }}</strong> 家门店：</p>
        <div class="void-target-list">
          <div v-for="d in voidDealerTargets.slice(0, 10)" :key="d.dealerCode">
            {{ d.dealerCode }} {{ d.dealerName }}
          </div>
          <div v-if="voidDealerTargets.length > 10" style="color:#94a3b8;font-size:12px;">……共 {{ voidDealerTargets.length }} 家</div>
        </div>
        <el-alert type="warning" :closable="false" show-icon style="margin: 8px 0;">
          <div slot="title">
            本次操作将：
            <ul style="margin:6px 0 0 16px; padding:0; font-size:13px;">
              <li>作废该门店该波次下的所有已提交答卷（status→3）</li>
              <li>清空所有草稿答卷 + Redis 缓存</li>
              <li>重置门店状态与邀请为"未开始 / 未打开"</li>
              <li>神客用原链接重新进入时会看到空白问卷，可重新做</li>
            </ul>
            所有快照已备份，可恢复。
          </div>
        </el-alert>
        <el-input type="textarea" v-model="voidDealerReason" :rows="3" maxlength="500" show-word-limit
                  placeholder="请填写作废原因（至少 10 字）"></el-input>
      </div>
      <div slot="footer">
        <el-button @click="voidDealerDialogVisible = false" round>取消</el-button>
        <el-button type="danger" :loading="voidDealerSubmitting" @click="submitVoidDealer" round>确认作废</el-button>
      </div>
    </el-dialog>

    <!-- ===== 恢复门店弹窗（无冲突） ===== -->
    <el-dialog title="恢复门店" :visible.sync="unvoidDialogVisible" width="540px" :close-on-click-modal="false">
      <div v-if="unvoidDialogTarget">
        <p>门店：<strong>{{ unvoidDialogTarget.dealerCode }} {{ unvoidDialogTarget.dealerName }}</strong></p>
        <el-alert type="info" :closable="false" show-icon style="margin: 8px 0;">
          <div slot="title">
            本次恢复将：
            <ul style="margin:6px 0 0 16px; padding:0; font-size:13px;">
              <li>回灌作废前的全部答卷与草稿</li>
              <li>门店状态 / 邀请记录回滚至作废前</li>
            </ul>
          </div>
        </el-alert>
        <el-input type="textarea" v-model="unvoidDialogReason" :rows="3" maxlength="500" show-word-limit
                  placeholder="请填写恢复原因（至少 10 字）"></el-input>
      </div>
      <div slot="footer">
        <el-button @click="unvoidDialogVisible = false" round>取消</el-button>
        <el-button type="primary" :loading="unvoidDialogSubmitting" @click="submitUnvoidDealer(null)" round>确认恢复</el-button>
      </div>
    </el-dialog>

    <!-- ===== 恢复冲突二选一弹窗（42 号方案 §10.8.4）===== -->
    <el-dialog title="恢复门店 · 检测到冲突" :visible.sync="conflictDialogVisible" width="580px" :close-on-click-modal="false">
      <div v-if="unvoidDialogTarget">
        <p>门店：<strong>{{ unvoidDialogTarget.dealerCode }} {{ unvoidDialogTarget.dealerName }}</strong></p>
        <el-alert type="warning" :closable="false" show-icon style="margin: 8px 0;">
          <div slot="title">
            检测到作废后神客已重新填写了 <strong>{{ conflictDialogNewCount }}</strong> 份答卷，请选择处理方式：
          </div>
        </el-alert>
        <el-radio-group v-model="conflictChoice" class="conflict-radio-group">
          <el-radio label="overwrite" class="conflict-radio">
            <div class="conflict-opt-title">覆盖新数据恢复旧的</div>
            <div class="conflict-opt-desc">神客新提交的 {{ conflictDialogNewCount }} 份答卷将作废并写入历史；作废前的数据恢复为当前生效。</div>
          </el-radio>
          <el-radio label="abort" class="conflict-radio">
            <div class="conflict-opt-title">保留新数据放弃恢复</div>
            <div class="conflict-opt-desc">不执行任何数据变更；神客新提交的数据继续生效；操作原因仍会留痕。</div>
          </el-radio>
        </el-radio-group>
        <el-input type="textarea" v-model="unvoidDialogReason" :rows="3" maxlength="500" show-word-limit
                  placeholder="请填写操作原因（至少 10 字）"></el-input>
      </div>
      <div slot="footer">
        <el-button @click="conflictDialogVisible = false" round>取消</el-button>
        <el-button type="primary" :loading="unvoidDialogSubmitting"
                   :disabled="!conflictChoice"
                   @click="submitUnvoidDealer(conflictChoice)" round>
          确认
        </el-button>
      </div>
    </el-dialog>

    <!-- ===== 作废日志抽屉 ===== -->
    <el-drawer title="门店作废日志" :visible.sync="voidLogDrawerVisible" direction="rtl" size="460px">
      <div class="void-log-timeline" v-loading="voidLogLoading">
        <el-empty v-if="!voidLogLoading && voidLogList.length === 0" description="暂无日志"></el-empty>
        <div v-else>
          <div v-for="l in voidLogList" :key="l.id" class="void-log-item" :class="'log-type-' + l.actionType">
            <div class="void-log-head">
              <span class="log-action-tag" :class="'log-tag-' + l.actionType">{{ l.actionTypeText }}</span>
              <span class="log-time">{{ l.actionAt }}</span>
            </div>
            <div class="log-meta">操作人：{{ l.actionByName || l.actionBy }}</div>
            <div class="log-reason" v-if="l.actionReason">{{ l.actionReason }}</div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import axios from 'index/axios'
import { getWaveList, getWaveDealers } from 'index/api/project/wave'
import { getQcPool, getQcPending, claimDealers, releaseDealers, assignDealers, rejectDealers, getMyRole } from 'index/api/project/qcReview'

// 主审核阶段编号（phaseNo=3）。42 号方案 §2.2 固定此值为 3，供 statusOptions / applyReviewFilter / getPhaseData 共享
const MAIN_REVIEW_PHASE_NO = 3

export default {
  name: 'ProjectData',

  data() {
    return {
      loading: false,
      waveOptions: [],
      selectedWaveId: null,
      tableData: [],
      page: 1,
      pageSize: 20,
      total: 0,
      currentPhases: [],
      dataStats: { totalDealers: 0, submittedCount: 0, pendingReview: 0, completionRate: 0 },
      searchKeyword: '',
      reviewFilter: null,
      phaseFilter: null,
      statusFilter: null,
      appealFilter: null,
      qcFilter: null,
      allTableData: [],
      selectedRows: [],
      appealDialogVisible: false,
      appealSubmitting: false,
      appealDialogMode: 'selection',
      appealForm: { batchName: '', startTime: '', endTime: '', appealYear: new Date().getFullYear(), appealMonthNum: new Date().getMonth() + 1 },
      batchAppealText: '',
      batchCheckResult: [],
      batchChecking: false,
      appealStatusMap: {},
      exporting: false,
      exportProgress: 0,
      // QC 门店池
      poolDialogVisible: false, pendingDialogVisible: false,
      poolData: [], poolLoading: false, poolPage: 1, poolTotal: 0, poolKeyword: '',
      poolSelected: [], myClaimCount: 0, maxClaimCount: 5,
      isReviewerRole: false, isInternalQc: false,
      pendingData: [], pendingLoading: false, pendingPage: 1, pendingTotal: 0, pendingKeyword: '',
      reviewerOptions: [],
      releaseDialogVisible: false, releaseSubmitting: false,
      releaseForm: { tag: '', remark: '' }, releaseDealerIds: [],
      assignDialogVisible: false, assignSubmitting: false,
      assignForm: { userId: null }, assignDealerIds: [], assignWaveDealerIds: [],

      // ===== 42 号方案 §10.8：门店级作废 / 恢复 =====
      // dealerCode → { voided: bool, reason, byName, at } 的本地缓存（按当前表格批次加载）
      dealerVoidMap: {},
      // 作废弹窗
      voidDealerDialogVisible: false,
      voidDealerTargets: [],       // [{ dealerCode, dealerName }]
      voidDealerReason: '',
      voidDealerSubmitting: false,
      // 恢复弹窗（无冲突）
      unvoidDialogVisible: false,
      unvoidDialogTarget: null,
      unvoidDialogReason: '',
      unvoidDialogSubmitting: false,
      // 冲突二选一弹窗
      conflictDialogVisible: false,
      conflictDialogNewCount: 0,
      conflictChoice: '',
      // 作废日志抽屉
      voidLogDrawerVisible: false,
      voidLogLoading: false,
      voidLogList: []
    }
  },

  computed: {
    projectId() { return this.$route.params.projectId },

    // 42 号方案 §10.4 / §10.8.5：作废/恢复 仅限研究员 + 管理员
    canGovernDealer() {
      const info = this.$store.getters.userInfo || {}
      const roleName = (info.roles && info.roles.name) || info.role_name || info.roleName || ''
      const roleCode = info.role_code || (info.roles && info.roles.code) || ''
      if (['研究员', 'RD'].includes(roleName) || ['RD', 'rd'].includes(roleCode)) return true
      if (['管理员', '超级管理员', 'admin', 'superadmin'].includes(roleName)) return true
      return false
    },

    // 超级管理员（删除按钮的唯一可见角色，§10.8.7）
    isSuperAdmin() {
      const info = this.$store.getters.userInfo || {}
      const roleName = (info.roles && info.roles.name) || info.role_name || info.roleName || ''
      return ['超级管理员', 'superadmin'].includes(roleName)
    },

    isQcRole() {
      const info = this.$store.getters.userInfo || {}
      const sysRole = (info.roles && info.roles.name) || info.role_name || info.roleName || ''
      return sysRole === '质量控制'
    },

    isOpsRole() {
      const info = this.$store.getters.userInfo || {}
      const sysRole = (info.roles && info.roles.name) || info.role_name || info.roleName || ''
      return sysRole === '执行'
    },
    canDistributeAppeal() {
      return !this.isReviewerRole && !this.isInternalQc
    },
    batchCanAppealCount() {
      return Array.isArray(this.batchCheckResult) ? this.batchCheckResult.filter(r => r.canAppeal).length : 0
    },
    batchWaveWarning() {
      if (!Array.isArray(this.batchCheckResult)) return false
      const waves = [...new Set(this.batchCheckResult.filter(r => r.canAppeal && r.waveName).map(r => r.waveName))]
      return waves.length > 1
    },
    // 根据当前选中阶段动态生成状态筛选选项
    // 改造说明（42 号方案 §8）：筛选文案与单元格 getPhaseData 输出一对一对齐
    statusOptions() {
      // 主审核阶段（phaseNo=3 / MAIN_REVIEW_PHASE_NO）：三级审核全流程
      if (this.phaseFilter === MAIN_REVIEW_PHASE_NO) {
        return [
          { label: '未填写', value: 'not_started' },
          { label: '填写中', value: 'in_progress' },
          { label: '待一审', value: 'pending_review_1' },
          { label: '一审完成', value: 'review_done_1' },
          { label: '二审完成', value: 'review_done_2' },
          { label: '三审完成', value: 'review_done_3' },
          { label: '已驳回', value: 'rejected' }
        ]
      }
      // 简化审核阶段（1/2/4）：严格按单元格显示的 5 种状态
      return [
        { label: '未填写', value: 'not_started' },
        { label: '填写中', value: 'in_progress' },
        { label: '已提交', value: 'submitted' },
        { label: '已通过', value: 'approved' },
        { label: '已驳回', value: 'rejected' }
      ]
    },
    qcAccountOptions() {
      const names = this.allTableData.map(d => d.qcName).filter(Boolean)
      return [...new Set(names)].sort()
    }
  },

  mounted() { this.loadWaves(); this.loadMyRole() },

  watch: {
    projectId: { immediate: false, handler() { this.loadWaves() } },
    // 切换阶段时清空状态筛选（因为选项不同）
    phaseFilter() { this.statusFilter = null }
  },

  methods: {
    async loadMyRole() {
      if (!this.projectId) return
      try {
        const res = await getMyRole(this.projectId)
        const d = res?.data?.data || res?.data || {}
        this.isReviewerRole = !!d.isReviewer
        this.isInternalQc = !!d.isInternalQc
        if (d.maxClaim) this.maxClaimCount = d.maxClaim
      } catch (e) { /* 非QC用户不报错 */ }
    },
    async loadWaves() {
      if (!this.projectId) return
      try {
        const res = await getWaveList(this.projectId)
        const data = res?.data?.data || res?.data || {}
        const allWaves = data.Rows || data.rows || []
        this.waveOptions = allWaves.map(w => ({ id: w.Id || w.id, name: w.Name || w.name, phases: w.Phases || w.phases || [] }))
        const savedId = sessionStorage.getItem(`data_wave_${this.projectId}`)
        if (savedId) {
          const numId = Number(savedId)
          if (this.waveOptions.some(w => w.id === numId)) { this.selectedWaveId = numId; this.loadDealerData() }
        }
      } catch (e) {
        const data = e?.data?.data || e?.data || {}
        const rows = data.Rows || data.rows || []
        if (rows.length > 0) {
          this.waveOptions = rows.map(w => ({ id: w.Id || w.id, name: w.Name || w.name, phases: w.Phases || w.phases || [] }))
        } else { console.error('加载波次列表失败', e) }
      }
    },

    async loadDealerData() {
      if (!this.selectedWaveId) { this.tableData = []; this.currentPhases = []; return }
      // 每次重新加载数据时清空选中状态，避免筛选/翻页后选中行残留
      this.selectedRows = []
      this.$nextTick(() => {
        if (this.$refs.dataTable) this.$refs.dataTable.clearSelection()
      })
      sessionStorage.setItem(`data_wave_${this.projectId}`, this.selectedWaveId)

      const wave = this.waveOptions.find(w => w.id === this.selectedWaveId)
      if (wave && Array.isArray(wave.phases)) {
        this.currentPhases = wave.phases.map((p, i) => ({
          phaseNo: parseInt(p.phaseNo || p.PhaseNo) || (i + 1),
          phaseName: p.phaseName || p.PhaseName || `阶段${i + 1}`,
          formId: p.formId || p.FormId || ''
        }))
        // 兼职QC隐藏第1阶段（神秘客研究信息），显示2/3/4
        if (this.isReviewerRole) {
          this.currentPhases = this.currentPhases.filter(p => p.phaseNo !== 1)
        }
      }

      this.loading = true
      try {
        const params = { WaveId: this.selectedWaveId, Page: this.page, PageSize: this.pageSize, HasSubmission: true }
        if (this.searchKeyword) params.Keyword = this.searchKeyword

        const res = await getWaveDealers(this.selectedWaveId, params)
        const data = res?.data?.data || res?.data || {}
        const rows = data.Rows || data.rows || []

        this.tableData = rows.map(d => ({
          dealerId: d.Id || d.id,
          dealerCode: d.DealerCode || d.dealerCode,
          dealerName: d.DealerName || d.dealerName,
          agentName: d.AgentName || d.agentName,
          qcName: d.QcName || d.qcName,
          uniqueCode: d.UniqueCode || d.uniqueCode,
          phases: d.PhaseStatuses || d.phaseStatuses || []
        }))
        this.total = data.TotalRows || data.totalRows || data.Total || data.total || 0
        this.allTableData = [...this.tableData]
        this.computeStats()
        if (this.phaseFilter != null || this.statusFilter != null) this.applyReviewFilter()
        if (this.qcFilter) this.applyQcFilter()
        await this.loadAppealStatus()
        if (this.appealFilter) this.applyAppealFilter()
        // 42 号方案 §10.8.7：加载各门店作废状态以渲染灰度 Tag
        if (this.canGovernDealer) this.loadDealerVoidStatus()
      } catch (e) {
        console.error('加载经销商数据失败', e)
        const data = e?.data?.data || e?.data || {}
        const rows = data.Rows || data.rows || []
        if (rows.length > 0) {
          this.tableData = rows.map(d => ({
            dealerId: d.Id || d.id, dealerCode: d.DealerCode || d.dealerCode,
            dealerName: d.DealerName || d.dealerName, agentName: d.AgentName || d.agentName,
            qcName: d.QcName || d.qcName,
            uniqueCode: d.UniqueCode || d.uniqueCode, phases: d.PhaseStatuses || d.phaseStatuses || []
          }))
          this.total = data.TotalRows || data.totalRows || 0
          this.computeStats()
        }
      } finally { this.loading = false }
    },

    // 改造说明（42 号方案 §8.4.1）：兼职 QC 视角下隐藏阶段 1 的列头/展开行，
    // 统计数字也需按同一白名单计算，避免"展示的阶段" ≠ "统计的阶段"
    visiblePhasesOf(row) {
      const phases = row.phases || []
      if (this.isReviewerRole) return phases.filter(p => Number(p.PhaseNo || p.phaseNo || 0) !== 1)
      return phases
    },

    computeStats() {
      const total = this.total
      let submitted = 0, pending = 0, allPhasesApproved = 0
      this.tableData.forEach(row => {
        const phases = this.visiblePhasesOf(row)
        if (phases.some(p => (p.Status || p.status || '') !== 'not_started')) submitted++
        if (phases.some(p => (p.Status || p.status || '') === 'submitted')) pending++
        if (phases.length > 0 && phases.every(p => (p.Status || p.status || '') === 'approved')) allPhasesApproved++
      })
      this.dataStats = {
        totalDealers: total, submittedCount: submitted, pendingReview: pending,
        completionRate: total > 0 ? Math.round((allPhasesApproved / total) * 100) : 0
      }
    },

    // 改造说明（42 号方案 §8.2）：判定条件与 getPhaseData 单元格文案一一对齐
    // - 主审核阶段（phaseNo=3）：7 档状态（未填写/填写中/待一审/一审完成/二审完成/三审完成/已驳回）
    // - 简化审核阶段（1/2/4）：5 档状态（未填写/填写中/已提交/已通过/已驳回），"已提交" 严格指 status==='submitted'
    applyReviewFilter() {
      if (this.phaseFilter == null && this.statusFilter == null) return
      this.tableData = this.tableData.filter(row => {
        // 兼职 QC 隐藏阶段 1：筛选范围统一对齐可见阶段
        const phases = this.visiblePhasesOf(row)
        // 如果选了阶段，则只看该阶段
        const targetPhases = this.phaseFilter != null
          ? phases.filter(p => (p.PhaseNo || p.phaseNo) === this.phaseFilter)
          : phases
        if (targetPhases.length === 0 && this.phaseFilter != null) return false
        if (!this.statusFilter) return targetPhases.length > 0
        return targetPhases.some(p => {
          const status = p.Status || p.status || 'not_started'
          const auditStatus = p.AuditStatus ?? p.auditStatus ?? 0
          const phaseNo = Number(p.PhaseNo || p.phaseNo || 0)
          const isMainPhase = phaseNo === MAIN_REVIEW_PHASE_NO
          switch (this.statusFilter) {
            // 通用两档
            case 'not_started': return status === 'not_started'
            case 'in_progress': return status === 'in_progress'
            // 已驳回：主审核阶段看 auditStatus=-1；简化阶段看 status==='rejected'
            case 'rejected':
              return isMainPhase ? auditStatus === -1 : status === 'rejected'
            // 主审核阶段四档（仅 phaseNo=3 有效）
            case 'pending_review_1': return isMainPhase && status === 'submitted' && auditStatus === 0
            case 'review_done_1':    return isMainPhase && auditStatus === 1
            case 'review_done_2':    return isMainPhase && auditStatus === 2
            case 'review_done_3':    return isMainPhase && auditStatus >= 3
            // 简化阶段三档（仅非主审核阶段有效）
            case 'submitted': return !isMainPhase && status === 'submitted'
            case 'approved':  return !isMainPhase && status === 'approved'
            default: return true
          }
        })
      })
    },

    applyAppealFilter() {
      if (this.appealFilter === 'appealed') {
        this.tableData = this.tableData.filter(row => (row.phases || []).some(p => this.appealStatusMap[(p.AnswerKey || p.answerKey)]))
      } else if (this.appealFilter === 'not_appealed') {
        this.tableData = this.tableData.filter(row => {
          const phases = row.phases || []
          return phases.some(p => (p.AnswerKey || p.answerKey)) && !phases.some(p => this.appealStatusMap[(p.AnswerKey || p.answerKey)])
        })
      }
    },

    applyQcFilter() {
      if (!this.qcFilter) return
      this.tableData = this.tableData.filter(row => row.qcName === this.qcFilter)
    },

    async loadAppealStatus() {
      try {
        const answerKeys = []
        this.tableData.forEach(row => (row.phases || []).forEach(p => { const k = p.AnswerKey || p.answerKey; if (k) answerKeys.push(k) }))
        if (answerKeys.length === 0) { this.appealStatusMap = {}; return }
        const res = await axios.post('/Appeal/answer/status', answerKeys)
        this.appealStatusMap = res?.data?.data || res?.data || res || {}
      } catch (e) { console.error('加载申诉状态失败', e); this.appealStatusMap = {} }
    },

    getPhaseData(row, phaseNo) {
      const pn = parseInt(phaseNo)
      const p = (row.phases || []).find(ph => parseInt(ph.PhaseNo || ph.phaseNo) === pn)
      if (!p) return { status: 'not_started', statusText: '未填写', answerKey: null }
      const status = p.Status || p.status || 'not_started'
      const auditStatus = p.AuditStatus ?? p.auditStatus ?? 0
      let statusText = p.StatusText || p.statusText || '未填写'
      // 主审核阶段（多级审核，phaseNo=3）：按 auditStatus 显示审核进度
      if (pn === MAIN_REVIEW_PHASE_NO && status !== 'not_started') {
        if (auditStatus === -1) statusText = '已驳回'
        else if (auditStatus === 0) statusText = '待一审'
        else if (auditStatus === 1) statusText = '一审完成'
        else if (auditStatus === 2) statusText = '二审完成'
        else if (auditStatus >= 3) statusText = '三审完成'
      }
      return {
        status,
        statusText,
        answerKey: p.AnswerKey || p.answerKey,
        formKey: p.FormKey || p.formKey,
        auditStatus,
        phaseNo: p.PhaseNo || p.phaseNo,
        phaseName: p.PhaseName || p.phaseName
      }
    },

    getRowPhases(row) {
      const phases = row.phases || []
      if (this.isReviewerRole) return phases.filter(p => (parseInt(p.PhaseNo || p.phaseNo) || 0) !== 1)
      return phases
    },

    isPhaseSubmitted(phase) {
      const s = phase.Status || phase.status || 'not_started'
      return s !== 'not_started'
    },

    getAuditStatus(phase) {
      return phase.AuditStatus || phase.auditStatus || 0
    },

    getPhaseNo(phase) {
      return phase.PhaseNo || phase.phaseNo || 0
    },

    getPhaseStatusClass(phase) {
      const s = phase.status || phase.Status || 'not_started'
      return { not_started: 'status-gray', in_progress: 'status-blue', submitted: 'status-orange', approved: 'status-green', rejected: 'status-red', reviewing: 'status-orange' }[s] || 'status-gray'
    },

    handlePhaseClick(row, phaseNo) {
      const data = this.getPhaseData(row, phaseNo)
      if (data.answerKey) this.reviewAnswer(data)
    },

    resolvePhaseFormKey(phase) {
      // 优先使用阶段数据中的 FormKey，其次回退到当前波次阶段配置里的 formId
      const directKey = phase.FormKey || phase.formKey || phase.Key || phase.key
      if (directKey) return directKey
      const phaseNo = Number(phase.PhaseNo || phase.phaseNo || 0)
      const matched = (this.currentPhases || []).find(p => Number(p.phaseNo) === phaseNo)
      return (matched && matched.formId) || ''
    },

    viewDetail(phase) {
      const key = this.resolvePhaseFormKey(phase)
      const answerKey = phase.AnswerKey || phase.answerKey
      if (!key || !answerKey) {
        this.$message.warning('缺少问卷参数，无法打开答卷详情')
        return
      }
      this.$router.push({ path: '/answer-preview', query: { key, answerKey } })
    },

    reviewAnswer(phase) {
      const key = this.resolvePhaseFormKey(phase)
      const answerKey = phase.AnswerKey || phase.answerKey
      if (!key || !answerKey) {
        this.$message.warning('缺少审核参数，无法进入审核页面')
        return
      }

      const query = { key, answerKey }
      const phaseNo = Number(phase.PhaseNo || phase.phaseNo || 0)
      if (phaseNo) query.phase = phaseNo
      if (phaseNo === MAIN_REVIEW_PHASE_NO) query.examForm = 1
      if (this.selectedWaveId) query.waveId = this.selectedWaveId
      this.$router.push({ path: '/grading', query })
    },

    deleteAnswer(phase) {
      const answerKey = phase.AnswerKey || phase.answerKey
      this.$confirm('确定删除该答卷吗？此操作不可恢复！', '警告', { type: 'warning', confirmButtonClass: 'el-button--danger' })
        .then(async () => {
          try { await axios.post(`/user/form/answer/delete/${answerKey}`); this.$message.success('删除成功'); this.loadDealerData() }
          catch (e) { this.$message.error('删除失败') }
        }).catch(() => {})
    },

    handleSearch() { this.page = 1; this.selectedRows = []; this.loadDealerData() },
    resetFilters() { this.searchKeyword = ''; this.phaseFilter = null; this.statusFilter = null; this.appealFilter = null; this.qcFilter = null; this.page = 1; this.selectedRows = []; this.loadDealerData() },
    handleSelectionChange(selection) { this.selectedRows = selection },

    async exportWaveData() {
      if (!this.selectedWaveId) return
      this.exporting = true; this.exportProgress = 0
      try {
        const wave = this.waveOptions.find(w => w.id === this.selectedWaveId)
        const waveName = wave ? wave.name : '波次'
        const baseURL = process.env.VUE_APP_BASE_URL || ''
        const token = localStorage.getItem('ACCESS_TOKEN')
        const url = `${baseURL}/WaveManager/wave/export-data?waveId=${this.selectedWaveId}`
        this.exportProgress = 10
        const response = await fetch(url, { method: 'GET', headers: { 'Authorization': `Bearer ${token}` } })
        this.exportProgress = 50
        if (!response.ok) {
          const text = await response.text()
          let errMsg = `导出失败 (错误码: ${response.status})`
          try { const errData = JSON.parse(text); errMsg = errData.message || errMsg } catch {}
          throw new Error(errMsg)
        }
        this.exportProgress = 70
        const blob = await response.blob()
        this.exportProgress = 90
        const blobUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = `${waveName}_数据导出_${this.formatDateForFilename(new Date())}.xlsx`
        link.click()
        window.URL.revokeObjectURL(blobUrl)
        this.exportProgress = 100
        this.$message.success('导出成功')
      } catch (e) { console.error('[Export] Error:', e); this.$message.error(e.message || '导出失败') }
      finally { this.exporting = false; this.exportProgress = 0 }
    },

    showAppealDialog() {
      if (!this.canDistributeAppeal) {
        this.$message.warning('QC 角色不允许下发申诉')
        return
      }
      if (this.selectedRows.length > 0) {
        this.appealDialogMode = 'selection'
        this.appealForm = { batchName: '', startTime: '', endTime: '', appealYear: new Date().getFullYear(), appealMonthNum: new Date().getMonth() + 1 }
        this.appealDialogVisible = true
      } else {
        this.appealDialogMode = 'batch'
        this.batchAppealText = ''; this.batchCheckResult = []
        this.appealForm = { batchName: '', startTime: '', endTime: '' }
        this.appealDialogVisible = true
      }
    },

    async parseBatchDealers() {
      const text = this.batchAppealText.trim()
      if (!text) { this.$message.warning('请输入店铺代码或名称'); return }
      const keywords = text.split(/[\r\n]+/).map(k => k.trim()).filter(k => k)
      if (keywords.length === 0) { this.$message.warning('没有可解析的内容'); return }
      this.batchChecking = true; this.batchCheckResult = []
      try {
        const examPhase = this.currentPhases.find(p => p.phaseNo === MAIN_REVIEW_PHASE_NO)
        const formKey = examPhase ? examPhase.formId : ''
        const res = await axios.post('/Appeal/batch/check', { projectId: Number(this.projectId), formKey, keywords })
        const data = res?.data?.data?.data || res?.data?.data || res?.data || res || []
        this.batchCheckResult = Array.isArray(data) ? data : []
        if (this.batchCheckResult.length === 0) this.$message.info('未匹配到任何结果')
      } catch (e) { console.error('解析失败', e); this.$message.error('解析失败') }
      finally { this.batchChecking = false }
    },

    async submitBatchAppeal() {
      if (!this.appealForm.startTime || !this.appealForm.endTime) { this.$message.warning('请设置申诉时间范围'); return }
      const canAppealItems = this.batchCheckResult.filter(r => r.canAppeal)
      const existingAppealItems = this.batchCheckResult.filter(r => r.matched && !r.canAppeal && r.message === '该店铺已存在申诉记录')
      if (canAppealItems.length === 0 && existingAppealItems.length === 0) { this.$message.warning('没有可下发的店铺'); return }
      let answerKeys = canAppealItems.map(r => r.answerKey)
      if (existingAppealItems.length > 0) {
        try {
          await this.$confirm(`列表中有 ${existingAppealItems.length} 份店铺已存在申诉记录。`, '存在已下发申诉', { confirmButtonText: '清除并下发', cancelButtonText: '仅下发新增', distinguishCancelAndClose: true, type: 'warning' })
          const existingKeys = existingAppealItems.map(r => r.answerKey)
          await axios.post('/Appeal/batch/delete-by-answers', { answerKeys: existingKeys })
          answerKeys = [...answerKeys, ...existingKeys]
        } catch (action) {
          if (action === 'cancel' && canAppealItems.length === 0) { this.$message.info('没有新增店铺可下发'); return }
          if (action !== 'cancel') return
        }
      }
      if (answerKeys.length === 0) { this.$message.warning('没有可下发的店铺'); return }
      this.navigateToDistribute(answerKeys.join(','))
      this.appealDialogVisible = false
    },

    submitAppeal() {
      // 只取主审核阶段（phaseNo=3）的 answerKey
      const answerKeys = this.selectedRows.flatMap(row => {
        const phases = row.phases || []
        const phase3 = phases.find(p => (p.PhaseNo || p.phaseNo) === MAIN_REVIEW_PHASE_NO)
        if (phase3) {
          const key = phase3.AnswerKey || phase3.answerKey
          return key ? [key] : []
        }
        return []
      }).join(',')
      if (!answerKeys) { this.$message.warning('所选门店没有第三阶段的答卷'); return }
      this.navigateToDistribute(answerKeys)
      this.appealDialogVisible = false
    },

    navigateToDistribute(answerKeys) {
      if (!answerKeys) { this.$message.warning('无效的答卷ID'); return }
      const query = { answerKeys, projectId: this.projectId }
      if (this.appealForm.batchName) query.batchName = this.appealForm.batchName
      if (this.appealForm.startTime) query.startTime = this.appealForm.startTime
      if (this.appealForm.endTime) query.endTime = this.appealForm.endTime
      const appealMonth = this.appealForm.appealYear + '-' + String(this.appealForm.appealMonthNum).padStart(2, '0')
      if (appealMonth) query.appealMonth = appealMonth
      this.$router.push({ path: '/appeal-distribute', query })
    },

    formatTime(timeStr) {
      if (!timeStr) return '-'
      return new Date(timeStr).toLocaleString('zh-CN')
    },
    formatDuration(seconds) {
      if (!seconds || seconds <= 0) return '-'
      const mins = Math.floor(seconds / 60), secs = seconds % 60
      return mins > 0 ? `${mins}分${secs}秒` : `${secs}秒`
    },
    formatDateForFilename(date) {
      const y = date.getFullYear(), m = String(date.getMonth() + 1).padStart(2, '0'), d = String(date.getDate()).padStart(2, '0')
      const h = String(date.getHours()).padStart(2, '0'), min = String(date.getMinutes()).padStart(2, '0')
      return `${y}${m}${d}_${h}${min}`
    },

    // ========== QC 门店池方法 ==========

    openPoolDialog() {
      this.poolDialogVisible = true
      this.loadPool()
    },
    openPendingDialog() {
      this.pendingDialogVisible = true
      this.loadPending()
    },

    async loadPool() {
      this.poolLoading = true
      try {
        const params = { ProjectId: parseInt(this.projectId), Keyword: this.poolKeyword, Page: this.poolPage, PageSize: 20 }
        if (this.selectedWaveId) params.WaveId = this.selectedWaveId
        const res = await getQcPool(params)
        const data = res?.data?.data || res?.data || {}
        this.poolData = data.records || []
        this.poolTotal = data.total || 0
        this.myClaimCount = data.myClaimCount || 0
        this.maxClaimCount = data.maxClaimCount || 5
      } catch (e) { console.error('加载取店池失败', e); this.$message.error('加载取店池失败') }
      finally { this.poolLoading = false }
    },

    async loadPending() {
      this.pendingLoading = true
      try {
        const res = await getQcPending({ ProjectId: parseInt(this.projectId), Keyword: this.pendingKeyword, Page: this.pendingPage, PageSize: 20 })
        const data = res?.data?.data || res?.data || {}
        this.pendingData = data.records || []
        this.pendingTotal = data.total || 0
        this.reviewerOptions = data.reviewers || []
      } catch (e) { console.error('加载待分配池失败', e); this.$message.error('加载待分配池失败') }
      finally { this.pendingLoading = false }
    },

    async claimOne(row) {
      try {
        await this.$confirm(`确定取店「${row.dealerName}」吗？`, '确认取店', { type: 'info' })
        const res = await claimDealers({ ProjectId: parseInt(this.projectId), DealerIds: [row.dealerId] })
        const data = res?.data?.data || res?.data || {}
        if (data.claimed > 0) {
          this.$message.success('取店成功')
          this.poolDialogVisible = false
          this.loadDealerData()
        } else {
          this.$message.warning(data.skippedReasons?.[0] || '取店失败')
        }
      } catch (e) { if (e !== 'cancel') { this.$message.error(e?.data?.message || e?.message || '取店失败') } }
    },

    async batchClaim() {
      if (this.poolSelected.length === 0) return
      try {
        await this.$confirm(`确定取店 ${this.poolSelected.length} 家门店吗？`, '批量取店', { type: 'info' })
        const ids = this.poolSelected.map(r => r.dealerId)
        const res = await claimDealers({ ProjectId: parseInt(this.projectId), DealerIds: ids })
        const data = res?.data?.data || res?.data || {}
        this.$message.success(`成功取 ${data.claimed || 0} 家，跳过 ${data.skipped || 0} 家`)
        this.poolDialogVisible = false
        this.loadDealerData()
      } catch (e) { if (e !== 'cancel') { this.$message.error(e?.data?.message || e?.message || '取店失败') } }
    },

    showReleaseDialog(rows) {
      this.releaseDealerIds = rows.map(r => r.dealerId)
      this.releaseForm = { tag: '', remark: '' }
      this.releaseDialogVisible = true
    },

    async confirmRelease() {
      if (!this.releaseForm.tag) { this.$message.warning('请选择释放标签'); return }
      if ((this.releaseForm.tag === '样本不全' || this.releaseForm.tag === '其他') && !this.releaseForm.remark) {
        this.$message.warning('请填写备注'); return
      }
      this.releaseSubmitting = true
      try {
        const res = await releaseDealers({
          ProjectId: parseInt(this.projectId),
          DealerIds: this.releaseDealerIds,
          Tag: this.releaseForm.tag,
          Remark: this.releaseForm.remark
        })
        const data = res?.data?.data || res?.data || {}
        const skippedByAudit = data.skippedByAudit || []
        if ((data.released || 0) > 0) {
          let msg = `成功释放 ${data.released} 家`
          if (skippedByAudit.length > 0) msg += `，${skippedByAudit.length} 家因审核已完成无法释放`
          this.$message.success(msg)
        } else if (skippedByAudit.length > 0) {
          this.$message.warning(`以下门店审核已完成，无法释放：${skippedByAudit.join('、')}`)
        } else {
          const debug = (data.debugInfo || []).join('; ')
          this.$message.warning(`未找到可释放的门店: ${debug}`)
        }
        this.releaseDialogVisible = false
        this.loadPool()
        this.loadDealerData()
      } catch (e) { this.$message.error(e?.data?.message || e?.message || '释放失败') }
      finally { this.releaseSubmitting = false }
    },

    showAssignDialog(row) {
      this.assignDealerIds = [row.dealerId]
      this.assignWaveDealerIds = [row.waveDealerId]
      this.assignForm = { userId: null }
      this.assignDialogVisible = true
    },

    async confirmAssign() {
      if (!this.assignForm.userId) { this.$message.warning('请选择兼职QC'); return }
      this.assignSubmitting = true
      try {
        await assignDealers({
          ProjectId: parseInt(this.projectId),
          DealerIds: this.assignDealerIds,
          WaveDealerIds: this.assignWaveDealerIds || [],
          AssignToUserId: this.assignForm.userId
        })
        this.$message.success('指派成功')
        this.assignDialogVisible = false
        this.loadPending()
      } catch (e) { this.$message.error(e?.data?.message || e?.message || '指派失败') }
      finally { this.assignSubmitting = false }
    },

    async rejectDealer(row) {
      try {
        const { value } = await this.$prompt('请填写驳回原因', '驳回门店', {
          confirmButtonText: '确认驳回', cancelButtonText: '取消', inputType: 'textarea',
          inputPlaceholder: '请填写驳回原因（可选）'
        })
        await rejectDealers({
          ProjectId: parseInt(this.projectId),
          DealerIds: [row.dealerId],
          Remark: value || ''
        })
        this.$message.success('驳回成功')
        this.loadPending()
      } catch (e) { if (e !== 'cancel' && e?.action !== 'cancel') { this.$message.error(e?.data?.message || e?.message || '驳回失败') } }
    },

    goReview(row) {
      // 跳转到审核页面（复用现有的 reviewAnswer 逻辑）
      this.$message.info('请在数据管理列表中找到对应门店进行审核')
      this.poolDialogVisible = false
    },

    // ===== 42 号方案 §10.8：门店级作废 / 恢复 =====

    isDealerVoided(row) {
      const info = this.dealerVoidMap[row.dealerCode]
      return info && info.isVoided
    },

    dealerVoidInfo(row) {
      const v = this.dealerVoidMap[row.dealerCode] || {}
      return { reason: v.lastReason, by: v.lastByName, at: v.lastAt }
    },

    async loadDealerVoidStatus() {
      if (!this.selectedWaveId) return
      const codes = this.tableData.map(r => r.dealerCode).filter(Boolean)
      if (codes.length === 0) { this.dealerVoidMap = {}; return }
      try {
        const { getDealerVoidStatus } = await import('index/api/project/qcReview')
        const res = await getDealerVoidStatus({ waveId: this.selectedWaveId, dealerCodes: codes })
        const records = res?.data?.data?.records || res?.data?.records || []
        const map = {}
        records.forEach(r => { map[r.dealerCode] = r })
        this.dealerVoidMap = map
      } catch (e) { console.warn('加载门店作废状态失败', e) }
    },

    openVoidDealerDialog(row) {
      this.voidDealerTargets = [{ dealerCode: row.dealerCode, dealerName: row.dealerName }]
      this.voidDealerReason = ''
      this.voidDealerDialogVisible = true
    },

    openBatchVoidDialog() {
      if (!this.selectedRows || this.selectedRows.length === 0) return
      // 过滤已作废的
      const targets = this.selectedRows
        .filter(r => !this.isDealerVoided(r))
        .map(r => ({ dealerCode: r.dealerCode, dealerName: r.dealerName }))
      if (targets.length === 0) {
        this.$message.warning('所选门店均已作废')
        return
      }
      this.voidDealerTargets = targets
      this.voidDealerReason = ''
      this.voidDealerDialogVisible = true
    },

    async submitVoidDealer() {
      const reason = (this.voidDealerReason || '').trim()
      if (reason.length < 10) {
        this.$message.warning('请填写作废原因，不少于 10 字')
        return
      }
      this.voidDealerSubmitting = true
      try {
        const { voidDealer } = await import('index/api/project/qcReview')
        const res = await voidDealer({
          waveId: this.selectedWaveId,
          dealerCodes: this.voidDealerTargets.map(t => t.dealerCode),
          reason
        })
        const data = res?.data?.data || res?.data || {}
        this.$message.success(`已作废 ${data.voidedCount || 0} 家门店`)
        if (data.skipped && data.skipped.length) {
          console.info('跳过明细', data.skipped)
        }
        this.voidDealerDialogVisible = false
        // 刷新表格和作废状态
        await this.loadDealerData()
        await this.loadDealerVoidStatus()
      } catch (e) {
        this.$message.error(e?.data?.message || e?.message || '作废失败')
      } finally {
        this.voidDealerSubmitting = false
      }
    },

    openUnvoidDealerDialog(row) {
      this.unvoidDialogTarget = { dealerCode: row.dealerCode, dealerName: row.dealerName }
      this.unvoidDialogReason = ''
      this.conflictChoice = ''
      this.conflictDialogNewCount = 0
      this.unvoidDialogVisible = true
    },

    async submitUnvoidDealer(conflictResolution) {
      const reason = (this.unvoidDialogReason || '').trim()
      if (reason.length < 10) {
        this.$message.warning('请填写恢复原因，不少于 10 字')
        return
      }
      if (!this.unvoidDialogTarget) return
      this.unvoidDialogSubmitting = true
      try {
        const { unvoidDealer } = await import('index/api/project/qcReview')
        const payload = {
          waveId: this.selectedWaveId,
          dealerCodes: [this.unvoidDialogTarget.dealerCode],
          reason
        }
        if (conflictResolution) payload.conflictResolution = conflictResolution
        const res = await unvoidDealer(payload)
        const data = res?.data?.data || res?.data || {}
        // 后端用 errcode=409 表示需要走冲突二选一流程
        if (data.errcode === 409 && data.conflicts && data.conflicts.length > 0) {
          const c = data.conflicts[0]
          this.conflictDialogNewCount = c.newAnswerCount || (c.newAnswers && c.newAnswers.length) || 0
          this.unvoidDialogVisible = false
          this.conflictDialogVisible = true
          return
        }
        this.$message.success(data.restoredCount > 0 ? `已恢复 ${data.restoredCount} 家门店` : '已记录操作')
        this.unvoidDialogVisible = false
        this.conflictDialogVisible = false
        await this.loadDealerData()
        await this.loadDealerVoidStatus()
      } catch (e) {
        this.$message.error(e?.data?.message || e?.message || '恢复失败')
      } finally {
        this.unvoidDialogSubmitting = false
      }
    },

    async showDealerVoidLog(row) {
      if (!row || !row.dealerCode || !this.selectedWaveId) return
      this.voidLogDrawerVisible = true
      this.voidLogLoading = true
      try {
        const { getDealerVoidLog } = await import('index/api/project/qcReview')
        const res = await getDealerVoidLog(this.selectedWaveId, row.dealerCode)
        this.voidLogList = res?.data?.data?.records || res?.data?.records || []
      } catch (e) {
        console.error('加载作废日志失败', e)
        this.voidLogList = []
      } finally {
        this.voidLogLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.project-data { padding: 0; }

/* 42 号方案 §10.8.7：门店级作废相关样式 */
.voided-row-text {
  color: #94a3b8;
  text-decoration: line-through;
}
.dealer-void-actions {
  padding: 12px 16px 0;
  border-top: 1px dashed #e2e8f0;
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.void-target-list {
  max-height: 160px;
  overflow-y: auto;
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 13px;
  line-height: 1.8;
}
.conflict-radio-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 12px 0;
}
.conflict-radio {
  align-items: flex-start !important;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-right: 0 !important;
  white-space: normal !important;
  ::v-deep .el-radio__label {
    padding-left: 10px;
    white-space: normal;
  }
  &.is-checked {
    border-color: #409EFF;
    background: #ecf5ff;
  }
}
.conflict-opt-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}
.conflict-opt-desc {
  font-size: 12px;
  color: #64748b;
  margin-top: 4px;
  line-height: 1.5;
}
.void-log-timeline {
  padding: 0 20px 20px;
}
.void-log-item {
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 10px;
}
.void-log-head { display: flex; align-items: center; justify-content: space-between; }
.log-action-tag {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 600;
}
.log-tag-1 { background: #fee2e2; color: #b91c1c; }
.log-tag-2 { background: #dcfce7; color: #15803d; }
.log-tag-3 { background: #fef3c7; color: #b45309; }
.log-time { font-size: 12px; color: #94a3b8; }
.log-meta { font-size: 12px; color: #64748b; margin-top: 4px; }
.log-reason { font-size: 13px; color: #475569; margin-top: 4px; }

.page-header {
  display: flex; align-items: center; margin-bottom: 24px; gap: 16px;
  h3 { margin: 0; font-size: 20px; font-weight: 600; color: #1a1a2e; white-space: nowrap; }
  .header-center { flex: 1; }
  .header-actions { display: flex; gap: 8px; flex-shrink: 0; }
}

.form-select-inline { width: 240px; }
::v-deep .form-select-inline .el-input__inner { border-radius: 20px; padding-left: 90px; border: 1px solid #dcdfe6; height: 32px; line-height: 32px; font-size: 13px; }
::v-deep .form-select-inline .el-input__prefix { left: 12px; color: #606266; font-size: 13px; display: flex; align-items: center; }
::v-deep .form-select-inline .el-input__suffix { right: 8px; }

.header-actions .el-button--primary { background: #4c6ef5; border-color: #4c6ef5; border-radius: 6px; font-size: 13px; &:hover { background: #5c7cfa; border-color: #5c7cfa; } }

.stats-row { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin-bottom: 20px; }
.stat-card {
  position: relative; background: #fff; padding: 20px 20px 16px; border-radius: 12px; box-shadow: 0 1px 6px rgba(0,0,0,0.06); overflow: hidden;
  .stat-header { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; }
  .stat-label { font-size: 13px; color: #909399; font-weight: 500; }
  .stat-icon { position: absolute; top: 16px; right: 16px; width: 40px; height: 40px; border-radius: 10px; display: flex; align-items: center; justify-content: center;
    i { font-size: 20px; }
    &.icon-total { background: #eef2ff; i { color: #4c6ef5; } }
    &.icon-today { background: #e6f7ef; i { color: #52c41a; } }
    &.icon-week  { background: #fff7e6; i { color: #faad14; } }
    &.icon-time  { background: #f0f0f0; i { color: #909399; } }
  }
  .stat-value { font-size: 32px; font-weight: 700; color: #1a1a2e; line-height: 1.2; margin-bottom: 12px; }
  .stat-bar { height: 3px; width: 40px; border-radius: 2px; &.bar-blue { background: #4c6ef5; } }
}

.data-table { background: #fff; padding: 20px; border-radius: 12px; box-shadow: 0 1px 6px rgba(0,0,0,0.06); }
.table-toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; padding-bottom: 16px; border-bottom: 1px solid #f2f3f5; }
.search-input { width: 280px; }
::v-deep .search-input .el-input__inner { border-radius: 20px; height: 34px; line-height: 34px; font-size: 13px; border: 1px solid #e4e7ed; padding-left: 36px; }
::v-deep .search-input .el-input__prefix { left: 12px; }
.toolbar-icons { display: flex; align-items: center; gap: 12px; }
.toolbar-icon { font-size: 18px; color: #909399; cursor: pointer; transition: color 0.15s; &:hover { color: #4c6ef5; } }
.pagination { margin-top: 16px; text-align: right; }

/* 阶段状态标签 */
.phase-status-tag {
  display: inline-block; padding: 2px 10px; border-radius: 12px; font-size: 12px; font-weight: 500; white-space: nowrap; transition: all 0.15s;
  &.status-gray   { color: #909399; background: #f4f4f5; }
  &.status-blue   { color: #409eff; background: #ecf5ff; }
  &.status-orange  { color: #e6a23c; background: #fdf6ec; }
  &.status-green  { color: #67c23a; background: #f0f9eb; }
  &.status-red    { color: #f56c6c; background: #fef0f0; }
  &:hover { opacity: 0.85; }
}

/* 展开行详情 */
.expand-phases { display: flex; gap: 16px; padding: 12px 0; flex-wrap: wrap; }
.phase-detail-card { flex: 1; min-width: 200px; padding: 12px 16px; background: #fafafa; border-radius: 8px; border: 1px solid #f0f0f0; }
.phase-detail-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
.phase-detail-name { font-weight: 600; font-size: 13px; color: #303133; }
.phase-detail-info { font-size: 12px; color: #606266; display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 8px; }
.phase-detail-actions { display: flex; gap: 8px; }

.action-view { color: #4c6ef5 !important; font-size: 13px; &:hover { color: #364fc7 !important; } }
.action-audit { color: #e6a23c !important; font-size: 13px; font-weight: 500; &:hover { color: #cf9236 !important; } }
.action-delete { color: #f56c6c !important; font-size: 13px; &:hover { color: #e03e3e !important; } }
.phase-detail-actions { display: flex; gap: 12px; margin-top: 8px; padding-top: 8px; border-top: 1px dashed #ebeef5; }

.empty-state { text-align: center; padding: 60px 20px; color: #909399; i { font-size: 48px; margin-bottom: 16px; } p { font-size: 14px; } }
.filter-bar {
  display: flex; align-items: center; gap: 12px; margin-bottom: 16px; padding: 12px 16px; background: #fff; border-radius: 8px; border: 1px solid #ebeef5; flex-wrap: wrap;
  .el-button { border-radius: 20px; font-size: 13px; }
  .el-button--primary { background: #4c6ef5; border-color: #4c6ef5; &:hover { background: #5c7cfa; border-color: #5c7cfa; } }
  .el-button--default { border-color: #dcdfe6; color: #606266; &:hover { color: #4c6ef5; border-color: #c6d4ff; } }
  .el-button--warning { background: #e6a23c; border-color: #e6a23c; &:hover { background: #ebb563; border-color: #ebb563; } }
  .el-button--success { background: #67c23a; border-color: #67c23a; &:hover { background: #85ce61; border-color: #85ce61; } }
  .el-button--info { background: #909399; border-color: #909399; &:hover { background: #a6a9ad; border-color: #a6a9ad; } }
  .el-select .el-input__inner { border-radius: 20px; font-size: 13px; }
  .el-input__inner { border-radius: 20px; font-size: 13px; }
}

/* 门店池弹窗 */
::v-deep .pool-dialog {
  border-radius: 16px;
  overflow: hidden;
  .el-dialog__header {
    background: linear-gradient(135deg, #4c6ef5 0%, #748ffc 100%);
    padding: 16px 24px;
    .el-dialog__title { color: #fff; font-size: 16px; font-weight: 600; }
    .el-dialog__headerbtn .el-dialog__close { color: rgba(255,255,255,0.85); font-size: 18px; &:hover { color: #fff; } }
  }
  .el-dialog__body { padding: 16px 24px; }
  .el-dialog__footer { padding: 12px 24px 20px; border-top: 1px solid #f0f0f0; }
  .el-button { border-radius: 20px; }
  .el-button--primary { background: #4c6ef5; border-color: #4c6ef5; &:hover { background: #5c7cfa; border-color: #5c7cfa; } }
}
.pool-header {
  display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; padding-bottom: 12px; border-bottom: 1px solid #f0f0f0;
  .pool-info { display: flex; align-items: center; }
  .pool-count { font-size: 14px; color: #303133; b { color: #4c6ef5; font-size: 18px; } }
  .pool-actions { display: flex; align-items: center; gap: 8px; }
}
.review-done { color: #67c23a; font-size: 16px; font-weight: bold; }
.review-pending { color: #c0c4cc; font-size: 16px; }
.review-reject { color: #f56c6c; font-weight: 500; }
.review-pending-text { color: #909399; }

.export-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 9999; }
.export-progress-card {
  background: #fff; padding: 32px 48px; border-radius: 12px; text-align: center; min-width: 320px; box-shadow: 0 8px 32px rgba(0,0,0,0.15);
  i { font-size: 36px; color: #409eff; animation: spin 1s linear infinite; }
  .export-title { margin: 16px 0 12px; font-size: 16px; font-weight: 500; color: #303133; }
  .export-tip { font-size: 12px; color: #909399; margin-top: 12px; }
}
@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }

/* 下发申诉弹窗样式 */
::v-deep .appeal-dialog {
  border-radius: 16px;
  overflow: hidden;
  .el-dialog__header {
    background: linear-gradient(135deg, #4c6ef5 0%, #748ffc 100%);
    padding: 16px 24px;
    .el-dialog__headerbtn .el-dialog__close { color: rgba(255,255,255,0.85); font-size: 18px; &:hover { color: #fff; } }
  }
  .el-dialog__body { padding: 24px; }
  .el-dialog__footer { padding: 12px 24px 20px; border-top: 1px solid #f0f0f0; }
}
.dialog-custom-title {
  display: flex; align-items: center; gap: 8px; color: #fff; font-size: 16px; font-weight: 600;
  i { font-size: 20px; }
}
.appeal-form {
  .el-input__inner, .el-textarea__inner { border-radius: 8px; }
  .el-form-item__label { font-size: 13px; color: #606266; }
}
.appeal-count-badge {
  display: inline-block; background: #e8f0fe; color: #4c6ef5; padding: 2px 12px; border-radius: 12px; font-weight: 600; font-size: 13px;
}
.batch-result-summary {
  margin-top: 10px; color: #67c23a; font-size: 13px;
  strong { font-size: 16px; }
}
.dialog-footer {
  display: flex; justify-content: flex-end; gap: 8px;
  .el-button { border-radius: 20px; padding: 8px 24px; font-size: 13px; }
  .el-button--primary { background: #4c6ef5; border-color: #4c6ef5; &:hover { background: #5c7cfa; border-color: #5c7cfa; } }
}

</style>
